/* MODERN FSC 50 mm - seven decors that run on the same 50 mm price grids as
   the rest of the collection, but stop at 2700 mm wide instead of 3600.
   Rather than a second copy of the numbers, this family points at the very
   same W.CT array; only the width limit and the slat list differ, so the two
   can never drift apart. Loads after naru-wood-50b.js.
   Minimum width is 450 mm - the C+T price list starts there; 400 mm exists
   only on the Retro system, which is not sold. */
(function(){
var W=window.NARU_W50;
if(!W||!W.CT){return;}
window.NARU_W50F={
  CT:W.CT,
  GRP:W.GRP,
  SLATS:[
    {c:'20_50',g:2},{c:'21_50',g:2},{c:'23_50',g:2},{c:'24_50',g:2},
    {c:'25_50',g:2},{c:'26_50',g:2},{c:'27_50',g:2}
  ],
  FAM:{id:'w50f',mat:'wood',sw:50,grps:[0,1,2,3,5],groups:0,w0:0.5,h0:0.3,lim:[450,2700,300,4000],stack:[55,65]}
};
})();
